import { makeAutoObservable } from 'mobx'
import { mx } from 'store/base/mx'
import { InferenceStore } from 'store/inference/InferenceStore'

export class ImageQrModalStore {
  readonly inference: InferenceStore

  constructor(inference: InferenceStore) {
    this.inference = inference
    makeAutoObservable(this)
  }
}

export const imageQrModal = mx.ref<ImageQrModalStore>()
